import { styled } from "@mui/material/styles";

import { Colors, GreyPallet } from "../../config/styles";

interface StyledTextProps {
  inline?: boolean;
  canOverflow?: boolean;
  size: "title" | "subtitle" | "body" | "caption" | "small" | "tiny";
  color:
    | "inherit"
    | "white"
    | "black"
    | "light"
    | "regular"
    | "danger"
    | "ghost-regular"
    | "ghost-light"
    | "ghost-white";
}
export const StyledText = styled("p")<StyledTextProps>(
  ({ theme, size, color, inline, canOverflow }) => ({
    color:
      color === "black"
        ? GreyPallet.Black
        : color === "light"
        ? GreyPallet.Light
        : color === "regular"
        ? GreyPallet.Regular
        : color === "danger"
        ? Colors.Danger
        : color === "ghost-regular"
        ? GreyPallet.RegularGhost
        : color === "ghost-light"
        ? GreyPallet.LightGhost
        : color === "ghost-white"
        ? GreyPallet.WhiteGhost
        : color === "inherit"
        ? "inherit"
        : "#fff",
    fontSize:
      size === "title"
        ? 32
        : size === "subtitle"
        ? 24
        : size === "body"
        ? 16
        : size === "caption"
        ? 14
        : size === "small"
        ? 12
        : 10,

    fontWeight: "bold",
    margin: 0,
    lineHeight: 1.5,
    maxWidth: "100%",
    textOverflow: canOverflow ? "ellipsis" : "initial",
    overflow: canOverflow ? "hidden" : "initial",
    whiteSpace: canOverflow ? "nowrap" : "initial",
  })
);
